import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useNotifications } from 'src/utils/hooks';

const DELETE_ADDRESS_MUTATION = gql`
  mutation DeleteAddressWithRelatedData($params: DeleteAddressWithRelatedDataInput!) {
    deleteAddressWithRelatedData(params: $params) {
      addressId
    }
  }
`;

export const useAddressDelete = () => {
  const { showSuccessAlert, showErrorAlert } = useNotifications();
  const [deleteAddressMutation] = useMutation(DELETE_ADDRESS_MUTATION, {
    onCompleted: () => {
      showSuccessAlert('Site Deleted');
    },
    onError: (error) => {
      console.error(error);
      showErrorAlert(error.message ?? 'Something went wrong deleting site, please try again');
    },
  });

  const deleteAddress = useCallback(
    (addressId: string, hardDelete = false) => {
      return deleteAddressMutation({
        variables: {
          params: {
            addressId,
            softDelete: !hardDelete,
          },
        },
        optimisticResponse: {
          deleteAddressWithRelatedData: {
            addressId,
          },
        },
        update(cache) {
          const id = cache.identify({
            __typename: 'Address',
            id: addressId,
          });

          cache.evict({ id });
          cache.gc();
        },
      });
    },
    [deleteAddressMutation],
  );

  return { deleteAddress };
};
